import { GlobalStatus, InterviewType, StEnum } from "@gtpl/shared-models/common-models";
import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { interviewDTO } from "./dto/interview.dto";

@Entity('interview')
export class Interview {


    @PrimaryGeneratedColumn('increment', { name: 'interview_id' })
    interviewId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'interview_date',

    })
    interviewDate: Date;
    @Column({
        type: 'enum',
        enum: InterviewType,
        nullable: true,
        name: 'interview_type',

    })
    interviewType: InterviewType;

    @Column('varchar', {
        nullable: true,
        name: 'interviewer',
    })
    interviewer: string;

    @Column("varchar", {
        nullable: false,
        name: "willing"
      })
      willing: string;


    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'interviewer_mobile_no'
    })
    interviewerMobileNo: string;

    @Column('varchar', {
        nullable: false,
        name: 'plant'
    })
    plant: string;


    @Column('int', {
        name: 'notification_id'
    })
    notificationId: number;

    @Column({
        nullable: false,
        name: 'job_description'
    })
    jobDescription: string;

    @Column('varchar', {
        nullable: false,
        name: 'candidate_name'
    })
    candidateName: string;

    @Column({
        type: 'enum',
        enum: StEnum,
        nullable: true,
        name: 'status',

    })
    status: StEnum;

    @Column('varchar', {
        nullable: true,
        name: 'refereed_by'
    })
    refereedBy: string;

    @Column('varchar', {
        nullable: true,
        length: 60,
        name: 'remarks'
    })
    remarks: string;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;



}